module.exports = __webpack_public_path__ + "static/media/finacing-white.0b597cb6.svg";